import { useContext, useState } from 'react';
import { ListGroupItem, Button, Spinner, Row, Col } from 'react-bootstrap';
import { PencilFill, TrashFill, CheckLg, XCircleFill } from 'react-bootstrap-icons';
import ValidationOptionsInput from 'src/components/input/ValidationOptionsInput';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useAPI } from '../../services/api';
import ToastContext from 'src/contexts/toast-context';
import { roles } from '../../data/roles';

const userSchema = Yup.object().shape({
  role: Yup.number().integer(),
});

const User = ({ user, updateUsers }) => {
  const keys = ['username', 'displayName'];
  const [editingUser, setEditingUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const api = useAPI();
  user.role = user.userRole.role;
  const { handleError, success } = useContext(ToastContext);

  const save = async (values) => {
    try {
      setLoading(true);
      const { data: users } = await api.patch(`/users/${user.id}`, { role: parseInt(values.role) });
      updateUsers(users);
      setEditingUser(false);
      success('User saved!');
    } catch (e) {
      handleError(e);
    }
    setLoading(false);
  };

  const deleteUser = async () => {
    try {
      setLoading(true);
      const { data: users } = await api.delete(`/users/${user.id}`);
      updateUsers(users);
      success('User deleted!');
    } catch (e) {
      handleError(e);
      setLoading(false);
    }
  };

  const initialValues = {
    role: user.roleId,
  };

  if (editingUser) {
    return (
      <Formik onSubmit={save} initialValues={initialValues} validationSchema={userSchema}>
        <Form>
          <ListGroupItem
            className="d-md-flex justify-content-between align-items-center px-3 py-2 p-md-1"
            data-cy={`user-${user.id}`}
          >
            <Row className="flex-grow-1">
              {keys.map((key) => (
                <div
                  key={key}
                  className={`d-flex flex-column justify-content-center mb-3 col-sm-4`}
                >
                  <div data-cy={`value-${key}`}>{user[key]}</div>
                </div>
              ))}
              <ValidationOptionsInput options={roles} name="role" className="col-sm-4" noMargin />
            </Row>

            <div className="d-flex align-items-center mt-md-0 mt-1">
              <Button
                variant="success"
                type="submit"
                disabled={loading}
                className="d-flex align-items-center py-1 mx-1"
              >
                {loading ? (
                  <Spinner size="sm" animation="border" className="me-1" />
                ) : (
                  <CheckLg className="me-1" />
                )}
                Save
              </Button>

              <Button
                variant="danger"
                type="button"
                className="d-flex align-items-center py-1 mx-1"
                onClick={() => setEditingUser(false)}
              >
                <XCircleFill className="me-1" />
                Cancel
              </Button>
            </div>
          </ListGroupItem>
        </Form>
      </Formik>
    );
  }
  return (
    <ListGroupItem
      className="d-md-flex justify-content-between align-items-center text-dark px-3 py-2 p-md-1"
      data-cy={`user-${user.id}`}
    >
      <Row className="flex-grow-1">
        <Col xs={12} md={3} className="d-flex align-items-center">
          {user.username}
        </Col>
        <Col xs={12} md={3} className="d-flex align-items-center">
          {user.displayName}
        </Col>
        <Col xs={12} md={3} className="d-flex align-items-center">
          {user.role}
        </Col>

        <Col xs={12} md={3} className="d-flex align-items-center mt-md-0 mt-1">
          <Button
            type="button"
            className="d-flex align-items-center py-1 mx-1"
            onClick={() => setEditingUser(true)}
          >
            <PencilFill className="me-1" />
            Edit
          </Button>

          <Button
            variant="danger"
            type="button"
            className="d-flex align-items-center py-1 mx-1"
            onClick={deleteUser}
          >
            {loading ? (
              <Spinner size="sm" animation="border" className="me-1" />
            ) : (
              <TrashFill className="me-1" />
            )}
            Delete
          </Button>
        </Col>
      </Row>
    </ListGroupItem>
  );
};

export default User;
